export default __webpack_public_path__ + "static/Mont-HeavyItalic-5456ab3c64f6731a6eac7ff2d910c4e2.otf";